<template>
	<div style="height: 100%;position: relative;">
		<el-menu style="height: 100%;" @select="handleSelect" active-text-color="#E6A23C" :default-active="defaultActiveMenu">
			<el-menu-item index="/index/product">
				<template slot="title">
					<i class="el-icon-present"></i>
					<span>产品管理</span>
				</template>
			</el-menu-item>
			<el-menu-item index="/index/customer">
				<template slot="title">
					<i class="el-icon-s-custom"></i>
					<span>客户管理</span>
				</template>
			</el-menu-item>
			<el-menu-item index="/index/customerorder">
				<template slot="title">
					<i class="el-icon-message-solid"></i>
					<span>客户预约管理</span>
				</template>
			</el-menu-item>
			<el-menu-item index="/index/productnotice">
				<template slot="title">
					<i class="el-icon-chat-line-square"></i>
					<span>产品公告管理</span>
				</template>
			</el-menu-item>
			<el-menu-item index="/index/user" v-if="userInfo.type==1?true:false">
				<template slot="title">
					<i class="el-icon-user"></i>
					<span>系统用户管理</span>
				</template>
				<!--<el-menu-item-group>-->
				<!--<template slot="title">分组一</template>-->
				<!--<el-menu-item index="1-1">选项1</el-menu-item>-->
				<!--<el-menu-item index="1-2">选项2</el-menu-item>-->
				<!--</el-menu-item-group>-->
			</el-menu-item>
			<el-menu-item index="/index/orgconfig">
				<template slot="title">
					<i class="el-icon-setting"></i>
					<span>配置信息管理</span>
				</template>
			</el-menu-item>
		</el-menu>
		<div style="position: absolute;bottom: 120px;left: 5px;right: 5px;text-align: center;" lazy>
			<div style="font-size: 13px;line-height: 30px;">移动端二维码</div>
			<el-image style="width: 80px;height: 80px;" :src="getRrcode"></el-image>
		</div>
		<div style="position: absolute;bottom: 10px;left: 5px;right: 5px;text-align: center;">
			<!--<el-button size="small" type="danger" style="width: 100%;" @click="logOutHandler">退出登录</el-button>-->
			<el-image style="width: 80px;height: 80px;" src="https://cdn.meetingmeet.com/logo/512512.png"></el-image>
		</div>
	</div>
</template>
<script>

	import config from "../../config/global.js";
	var logoutUrl = config.host+"/backend/signout";

    export default {
        components: {
				},
				data:function () {
					return {
						defaultActiveMenu:"/index/product",
					}
				},
				mounted:function () {
					this.updateFocus();
				},
				computed:{
					userInfo:function () {
						return this.$store.getters.getUserInfo;
					},
					getRrcode:function () {
						if(this.org.frontqrcode == null )
							return "";
						return this.org.frontqrcode;
					}
				},
        methods: {
            handleSelect(index, indexPath) {
                this.$router.push({path: index, query: {gid: this.gid}});
            },
					updateFocus() {
						var path = this.$route.path;
						if(path.indexOf("/index/productnotice") != -1){
							this.defaultActiveMenu = "/index/productnotice";
						}else if(path.indexOf("/index/product") != -1 ){
							this.defaultActiveMenu = "/index/product";
						}else if(path.indexOf("/index/customerorder") != -1 ){
							this.defaultActiveMenu = "/index/customerorder";
						}else if(path.indexOf("/index/customer") != -1 ){
							this.defaultActiveMenu = "/index/customer";
						}else if(path.indexOf("/index/orgconfig") != -1 ){
							this.defaultActiveMenu = "/index/orgconfig";
						}
					},
					logOutHandler:function () {
            if(this.loading == false ){
            	this.loading = true;
							this.$http.get(logoutUrl,{}).then(
								function(response){
									var res = response.body;
									if(res.result==1){
										this.$store.commit("cleanUserInfo");
										this.$router.replace({name:"login"});
									}else{
										this.$message.error(res.emsg);
									}
									this.loading=false;
								},function(){
									this.$message.error("登出失败");
									this.loading=false;
								})
						}
					}
        },
        props:{
            gid:{
                type:String,
                required:false
            },
						org:{}
        }
    }
</script>



// WEBPACK FOOTER //
// src/layouts/Menu.vue